/// <reference path="./custom.d.ts" />
// tslint:disable
// @ts-nocheck
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:8281".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AccountBean
 */
export interface AccountBean {
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    id?: number;
    /**
     * Account name
     * @type {string}
     * @memberof AccountBean
     */
    name: string;
    /**
     * Account email
     * @type {string}
     * @memberof AccountBean
     */
    email: string;
    /**
     * Account password
     * @type {string}
     * @memberof AccountBean
     */
    password: string;
    /**
     * Account password confirm
     * @type {string}
     * @memberof AccountBean
     */
    passwordConfirm: string;
    /**
     * User role
     * @type {string}
     * @memberof AccountBean
     */
    role: AccountBean.RoleEnum;
    /**
     * User timezoneId
     * @type {string}
     * @memberof AccountBean
     */
    timezone?: string;
    /**
     * Active
     * @type {boolean}
     * @memberof AccountBean
     */
    active: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof AccountBean
     */
    managed?: Array<number>;
}

/**
 * @export
 * @namespace AccountBean
 */
export namespace AccountBean {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        Admin = <any> 'Admin',
        AgencyAdmin = <any> 'AgencyAdmin',
        AgencyManager = <any> 'AgencyManager'
    }
}
/**
 * 
 * @export
 * @interface AdGroupBean
 */
export interface AdGroupBean {
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    id?: number;
    /**
     * Name of AdGroup
     * @type {string}
     * @memberof AdGroupBean
     */
    name: string;
    /**
     * A brief description
     * @type {string}
     * @memberof AdGroupBean
     */
    description?: string;
    /**
     * Linked Campaign Id
     * @type {number}
     * @memberof AdGroupBean
     */
    campaignId: number;
    /**
     * An List of specific days of week and times when the ads should be active
     * @type {Array<Array<number>>}
     * @memberof AdGroupBean
     */
    schedule?: Array<Array<number>>;
    /**
     * Suitable country list
     * @type {Array<GeoBean>}
     * @memberof AdGroupBean
     */
    geoItems?: Array<GeoBean>;
    /**
     * Geo Precision
     * @type {string}
     * @memberof AdGroupBean
     */
    geoPrecision?: AdGroupBean.GeoPrecisionEnum;
    /**
     * Languages to be targeted
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    languages?: Array<string>;
    /**
     * Devices to be targeted
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    devices?: Array<AdGroupBean.DevicesEnum>;
    /**
     * Browsers to be targeted
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    browsers?: Array<AdGroupBean.BrowsersEnum>;
    /**
     * Suitable brands
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    brands?: Array<AdGroupBean.BrandsEnum>;
    /**
     * Platforms to be targeted
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    platforms?: Array<AdGroupBean.PlatformsEnum>;
    /**
     * AdGroup start date
     * @type {Date}
     * @memberof AdGroupBean
     */
    startDate: Date;
    /**
     * AdGroup end date
     * @type {Date}
     * @memberof AdGroupBean
     */
    endDate: Date;
    /**
     * Budget amount
     * @type {number}
     * @memberof AdGroupBean
     */
    totalBudget: number;
    /**
     * AdGroup daily budget
     * @type {number}
     * @memberof AdGroupBean
     */
    dailyBudget?: number;
    /**
     * AdGroup distribution type
     * @type {string}
     * @memberof AdGroupBean
     */
    distribution: AdGroupBean.DistributionEnum;
    /**
     * Preferred Bidding strategies like CPC, CPM, CPA
     * @type {string}
     * @memberof AdGroupBean
     */
    biddingStrategy: AdGroupBean.BiddingStrategyEnum;
    /**
     * Frequency capping period
     * @type {string}
     * @memberof AdGroupBean
     */
    fcPeriod?: AdGroupBean.FcPeriodEnum;
    /**
     * Frequency capping limit
     * @type {number}
     * @memberof AdGroupBean
     */
    fcLimit?: number;
    /**
     * AdGroup price
     * @type {number}
     * @memberof AdGroupBean
     */
    price: number;
    /**
     * Linked IAB categories
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    iabCategoryIds?: Array<number>;
    /**
     * Linked Content IAB categories
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    contentIabCategoryIds?: Array<number>;
    /**
     * status
     * @type {string}
     * @memberof AdGroupBean
     */
    status: AdGroupBean.StatusEnum;
    /**
     * Latitude
     * @type {number}
     * @memberof AdGroupBean
     */
    lat?: number;
    /**
     * Longitude
     * @type {number}
     * @memberof AdGroupBean
     */
    lon?: number;
    /**
     * Radius
     * @type {number}
     * @memberof AdGroupBean
     */
    radius?: number;
    /**
     * Enable this campaign only for private auctions
     * @type {boolean}
     * @memberof AdGroupBean
     */
    dealOnly: boolean;
    /**
     * Deal ID list
     * @type {string}
     * @memberof AdGroupBean
     */
    dealIdList?: string;
    /**
     * Linked Filter Lists
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    filterListIds?: Array<number>;
    /**
     * Advertiser domain
     * @type {string}
     * @memberof AdGroupBean
     */
    domain: string;
}

/**
 * @export
 * @namespace AdGroupBean
 */
export namespace AdGroupBean {
    /**
     * @export
     * @enum {string}
     */
    export enum GeoPrecisionEnum {
        GPSLocation = <any> 'GPSLocation',
        IPAddress = <any> 'IPAddress',
        GPSLocationAndIP = <any> 'GPSLocationAndIP'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DevicesEnum {
        Mobile = <any> 'Mobile',
        Desktop = <any> 'Desktop',
        Phone = <any> 'Phone',
        Tablet = <any> 'Tablet',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BrowsersEnum {
        InternetExplorer = <any> 'InternetExplorer',
        Opera = <any> 'Opera',
        Firefox = <any> 'Firefox',
        Chrome = <any> 'Chrome',
        Safari = <any> 'Safari',
        Edge = <any> 'Edge',
        WebView = <any> 'WebView',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BrandsEnum {
        Apple = <any> 'Apple',
        Samsung = <any> 'Samsung',
        Huawei = <any> 'Huawei',
        Xiaomi = <any> 'Xiaomi',
        Realme = <any> 'Realme',
        Poco = <any> 'Poco',
        Honor = <any> 'Honor',
        OnePlus = <any> 'OnePlus',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PlatformsEnum {
        Windows = <any> 'Windows',
        MacOS = <any> 'MacOS',
        IOS = <any> 'IOS',
        Linux = <any> 'Linux',
        Android = <any> 'Android',
        ChromeOS = <any> 'ChromeOS',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DistributionEnum {
        ASAP = <any> 'ASAP',
        Even = <any> 'Even'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BiddingStrategyEnum {
        CPM = <any> 'CPM',
        CPC = <any> 'CPC'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FcPeriodEnum {
        Minute = <any> 'Minute',
        Hour = <any> 'Hour',
        Day = <any> 'Day',
        Week = <any> 'Week',
        Month = <any> 'Month',
        Lifetime = <any> 'Lifetime'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        DRAFT = <any> 'DRAFT',
        CREATED = <any> 'CREATED',
        ACTIVE = <any> 'ACTIVE',
        INACTIVE = <any> 'INACTIVE',
        COMPLETED = <any> 'COMPLETED'
    }
}
/**
 * 
 * @export
 * @interface AdSizeBean
 */
export interface AdSizeBean {
    /**
     * 
     * @type {number}
     * @memberof AdSizeBean
     */
    id?: number;
    /**
     * Name of Ad Size
     * @type {string}
     * @memberof AdSizeBean
     */
    name: string;
    /**
     * Width
     * @type {number}
     * @memberof AdSizeBean
     */
    width: number;
    /**
     * Height
     * @type {number}
     * @memberof AdSizeBean
     */
    height: number;
}
/**
 * 
 * @export
 * @interface AdvertiserBean
 */
export interface AdvertiserBean {
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBean
     */
    id?: number;
    /**
     * Linked Media Agency
     * @type {number}
     * @memberof AdvertiserBean
     */
    mediaAgencyId: number;
    /**
     * Name of Advertiser
     * @type {string}
     * @memberof AdvertiserBean
     */
    name: string;
    /**
     * Advertiser Domain
     * @type {string}
     * @memberof AdvertiserBean
     */
    domain?: string;
    /**
     * active
     * @type {boolean}
     * @memberof AdvertiserBean
     */
    active: boolean;
    /**
     * Country name of the Advertiser
     * @type {string}
     * @memberof AdvertiserBean
     */
    countryId: string;
    /**
     * Description
     * @type {string}
     * @memberof AdvertiserBean
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ApiCreativeBody
 */
export interface ApiCreativeBody {
    /**
     * 
     * @type {Blob}
     * @memberof ApiCreativeBody
     */
    icon?: Blob;
    /**
     * 
     * @type {Blob}
     * @memberof ApiCreativeBody
     */
    file?: Blob;
}
/**
 * 
 * @export
 * @interface CampaignBean
 */
export interface CampaignBean {
    /**
     * 
     * @type {number}
     * @memberof CampaignBean
     */
    id?: number;
    /**
     * Name of Campaign
     * @type {string}
     * @memberof CampaignBean
     */
    name: string;
    /**
     * A brief description
     * @type {string}
     * @memberof CampaignBean
     */
    description?: string;
    /**
     * Status
     * @type {string}
     * @memberof CampaignBean
     */
    status: CampaignBean.StatusEnum;
    /**
     * Linked Advertiser Id
     * @type {number}
     * @memberof CampaignBean
     */
    advertiserId: number;
    /**
     * Linked SSP list
     * @type {Array<number>}
     * @memberof CampaignBean
     */
    sspIds?: Array<number>;
    /**
     * Campaign start date
     * @type {Date}
     * @memberof CampaignBean
     */
    startDate: Date;
    /**
     * Campaign end date
     * @type {Date}
     * @memberof CampaignBean
     */
    endDate: Date;
    /**
     * Campaign total budget
     * @type {number}
     * @memberof CampaignBean
     */
    totalBudget: number;
    /**
     * Campaign daily budget
     * @type {number}
     * @memberof CampaignBean
     */
    dailyBudget?: number;
    /**
     * Linked IAB categories
     * @type {Array<number>}
     * @memberof CampaignBean
     */
    iabCategoryIds?: Array<number>;
    /**
     * Linked Content IAB categories
     * @type {Array<number>}
     * @memberof CampaignBean
     */
    contentIabCategoryIds?: Array<number>;
    /**
     * Campaign language
     * @type {Array<string>}
     * @memberof CampaignBean
     */
    languages?: Array<string>;
    /**
     * Suitable country list
     * @type {Array<GeoBean>}
     * @memberof CampaignBean
     */
    geoItems?: Array<GeoBean>;
    /**
     * Geo Precision
     * @type {string}
     * @memberof CampaignBean
     */
    geoPrecision?: CampaignBean.GeoPrecisionEnum;
    /**
     * Suitable devices
     * @type {Array<string>}
     * @memberof CampaignBean
     */
    devices?: Array<CampaignBean.DevicesEnum>;
    /**
     * Suitable browsers
     * @type {Array<string>}
     * @memberof CampaignBean
     */
    browsers?: Array<CampaignBean.BrowsersEnum>;
    /**
     * Suitable brands
     * @type {Array<string>}
     * @memberof CampaignBean
     */
    brands?: Array<CampaignBean.BrandsEnum>;
    /**
     * Suitable platforms
     * @type {Array<string>}
     * @memberof CampaignBean
     */
    platforms?: Array<CampaignBean.PlatformsEnum>;
    /**
     * Latitude
     * @type {number}
     * @memberof CampaignBean
     */
    lat?: number;
    /**
     * Longitude
     * @type {number}
     * @memberof CampaignBean
     */
    lon?: number;
    /**
     * Radius
     * @type {number}
     * @memberof CampaignBean
     */
    radius?: number;
}

/**
 * @export
 * @namespace CampaignBean
 */
export namespace CampaignBean {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        DRAFT = <any> 'DRAFT',
        CREATED = <any> 'CREATED',
        ACTIVE = <any> 'ACTIVE',
        INACTIVE = <any> 'INACTIVE',
        COMPLETED = <any> 'COMPLETED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum GeoPrecisionEnum {
        GPSLocation = <any> 'GPSLocation',
        IPAddress = <any> 'IPAddress',
        GPSLocationAndIP = <any> 'GPSLocationAndIP'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DevicesEnum {
        Mobile = <any> 'Mobile',
        Desktop = <any> 'Desktop',
        Phone = <any> 'Phone',
        Tablet = <any> 'Tablet',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BrowsersEnum {
        InternetExplorer = <any> 'InternetExplorer',
        Opera = <any> 'Opera',
        Firefox = <any> 'Firefox',
        Chrome = <any> 'Chrome',
        Safari = <any> 'Safari',
        Edge = <any> 'Edge',
        WebView = <any> 'WebView',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BrandsEnum {
        Apple = <any> 'Apple',
        Samsung = <any> 'Samsung',
        Huawei = <any> 'Huawei',
        Xiaomi = <any> 'Xiaomi',
        Realme = <any> 'Realme',
        Poco = <any> 'Poco',
        Honor = <any> 'Honor',
        OnePlus = <any> 'OnePlus',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PlatformsEnum {
        Windows = <any> 'Windows',
        MacOS = <any> 'MacOS',
        IOS = <any> 'IOS',
        Linux = <any> 'Linux',
        Android = <any> 'Android',
        ChromeOS = <any> 'ChromeOS',
        Unknown = <any> 'Unknown'
    }
}
/**
 * 
 * @export
 * @interface CityBean
 */
export interface CityBean {
    /**
     * 
     * @type {string}
     * @memberof CityBean
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CityBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CountryBean
 */
export interface CountryBean {
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CreativeBean
 */
export interface CreativeBean {
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    id?: number;
    /**
     * Linked AdGroup Id
     * @type {number}
     * @memberof CreativeBean
     */
    adGroupId: number;
    /**
     * Name of Creative
     * @type {string}
     * @memberof CreativeBean
     */
    name: string;
    /**
     * Description for creative
     * @type {string}
     * @memberof CreativeBean
     */
    description?: string;
    /**
     * Creative type
     * @type {string}
     * @memberof CreativeBean
     */
    format: CreativeBean.FormatEnum;
    /**
     * Creative status
     * @type {boolean}
     * @memberof CreativeBean
     */
    active: boolean;
    /**
     * Redirect URL for click event
     * @type {string}
     * @memberof CreativeBean
     */
    landingUrl?: string;
    /**
     * List of Creative Attributes
     * @type {Array<string>}
     * @memberof CreativeBean
     */
    attribute?: Array<CreativeBean.AttributeEnum>;
    /**
     * Linked AdSize ID
     * @type {number}
     * @memberof CreativeBean
     */
    adSizeId: number;
    /**
     * HTML code of creative
     * @type {string}
     * @memberof CreativeBean
     */
    adCode?: string;
    /**
     * Image/Video file of creative
     * @type {string}
     * @memberof CreativeBean
     */
    file?: string;
    /**
     * 
     * @type {NativeBean}
     * @memberof CreativeBean
     */
    nativeData?: NativeBean;
}

/**
 * @export
 * @namespace CreativeBean
 */
export namespace CreativeBean {
    /**
     * @export
     * @enum {string}
     */
    export enum FormatEnum {
        Banner = <any> 'Banner',
        Video = <any> 'Video',
        Audio = <any> 'Audio',
        Native = <any> 'Native',
        HTML = <any> 'HTML',
        VAST = <any> 'VAST'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AttributeEnum {
        AudioAdAutoplay = <any> 'AudioAdAutoplay',
        AudioAdUserInitiated = <any> 'AudioAdUserInitiated',
        ExpandableAutomatic = <any> 'ExpandableAutomatic',
        ExpandableUserInitiatedClick = <any> 'ExpandableUserInitiatedClick',
        ExpandableUserInitiatedRollover = <any> 'ExpandableUserInitiatedRollover',
        InBannerVideoAdAutoplay = <any> 'InBannerVideoAdAutoplay',
        InBannerVideoAdUserInitiated = <any> 'InBannerVideoAdUserInitiated',
        PopOverUnderUponExit = <any> 'PopOverUnderUponExit',
        ProvocativeSuggestiveImagery = <any> 'ProvocativeSuggestiveImagery',
        ShakyFlashingFlickeringExtremeAnimationSmileys = <any> 'ShakyFlashingFlickeringExtremeAnimationSmileys',
        Surveys = <any> 'Surveys',
        TextOnly = <any> 'TextOnly',
        UserInteractiveEmbeddedGames = <any> 'UserInteractiveEmbeddedGames',
        WindowsDialogAlertStyle = <any> 'WindowsDialogAlertStyle',
        HasAudioButton = <any> 'HasAudioButton',
        AdProvidesSkipButton = <any> 'AdProvidesSkipButton',
        AdobeFlash = <any> 'AdobeFlash',
        ResponsiveSizelessFluid = <any> 'ResponsiveSizelessFluid'
    }
}
/**
 * 
 * @export
 * @interface CreativeBulkBody
 */
export interface CreativeBulkBody {
    /**
     * 
     * @type {Blob}
     * @memberof CreativeBulkBody
     */
    icon?: Blob;
    /**
     * 
     * @type {Array<Blob>}
     * @memberof CreativeBulkBody
     */
    files: Array<Blob>;
}
/**
 * 
 * @export
 * @interface CreativeIdBody
 */
export interface CreativeIdBody {
    /**
     * 
     * @type {Blob}
     * @memberof CreativeIdBody
     */
    icon?: Blob;
    /**
     * 
     * @type {Blob}
     * @memberof CreativeIdBody
     */
    file?: Blob;
}
/**
 * 
 * @export
 * @interface DeviceTypeBean
 */
export interface DeviceTypeBean {
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface EventReportKeyColumnDescription
 */
export interface EventReportKeyColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof EventReportKeyColumnDescription
     */
    column?: EventReportKeyColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof EventReportKeyColumnDescription
     */
    order?: EventReportKeyColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EventReportKeyColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {KeyFilterClause}
     * @memberof EventReportKeyColumnDescription
     */
    where?: KeyFilterClause;
}

/**
 * @export
 * @namespace EventReportKeyColumnDescription
 */
export namespace EventReportKeyColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        DayHour = <any> 'DayHour',
        Year = <any> 'Year',
        Month = <any> 'Month',
        Week = <any> 'Week',
        Day = <any> 'Day',
        SSP = <any> 'SSP',
        MediaAgency = <any> 'MediaAgency',
        Advertiser = <any> 'Advertiser',
        Campaign = <any> 'Campaign',
        AdGroup = <any> 'AdGroup',
        Creative = <any> 'Creative',
        AdSize = <any> 'AdSize',
        Country = <any> 'Country',
        Language = <any> 'Language',
        DeviceType = <any> 'DeviceType',
        MediaType = <any> 'MediaType',
        OS = <any> 'OS',
        Domain = <any> 'Domain',
        Bundle = <any> 'Bundle',
        RequestType = <any> 'RequestType',
        RequestAdSizes = <any> 'RequestAdSizes',
        ErrorReason = <any> 'ErrorReason',
        OptOut = <any> 'OptOut'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface EventReportValueColumnDescription
 */
export interface EventReportValueColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof EventReportValueColumnDescription
     */
    column?: EventReportValueColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof EventReportValueColumnDescription
     */
    order?: EventReportValueColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EventReportValueColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {ValueFilterClause}
     * @memberof EventReportValueColumnDescription
     */
    where?: ValueFilterClause;
}

/**
 * @export
 * @namespace EventReportValueColumnDescription
 */
export namespace EventReportValueColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        BidRequest = <any> 'BidRequest',
        Request = <any> 'Request',
        Bid = <any> 'Bid',
        Win = <any> 'Win',
        WinRate = <any> 'WinRate',
        Impression = <any> 'Impression',
        UniqImpression = <any> 'UniqImpression',
        Click = <any> 'Click',
        ErrorWin = <any> 'ErrorWin',
        ErrorImpression = <any> 'ErrorImpression',
        ErrorClick = <any> 'ErrorClick',
        VastStart = <any> 'VastStart',
        VastFirstQ = <any> 'VastFirstQ',
        VastMidpoint = <any> 'VastMidpoint',
        VastThirdQ = <any> 'VastThirdQ',
        VastComplete = <any> 'VastComplete',
        VastError = <any> 'VastError',
        VastClose = <any> 'VastClose',
        VastMute = <any> 'VastMute',
        VastUnmute = <any> 'VastUnmute',
        VastPause = <any> 'VastPause',
        VastResume = <any> 'VastResume',
        VastSkip = <any> 'VastSkip',
        ErrorVastEvent = <any> 'ErrorVastEvent',
        BidRate = <any> 'BidRate',
        FillRate = <any> 'FillRate',
        ClickThroughRate = <any> 'ClickThroughRate',
        ViewThroughRate = <any> 'ViewThroughRate',
        Cost = <any> 'Cost',
        CPM = <any> 'CPM',
        BidPrice = <any> 'BidPrice',
        AvgBidPrice = <any> 'AvgBidPrice',
        WinPrice = <any> 'WinPrice',
        AvgWinPrice = <any> 'AvgWinPrice',
        ErrorWinPrice = <any> 'ErrorWinPrice',
        ImprPrice = <any> 'ImprPrice',
        AvgImprPrice = <any> 'AvgImprPrice',
        ErrorImprPrice = <any> 'ErrorImprPrice',
        CostPerClick = <any> 'CostPerClick'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface FilterListBean
 */
export interface FilterListBean {
    /**
     * 
     * @type {number}
     * @memberof FilterListBean
     */
    id?: number;
    /**
     * Name of Filter list
     * @type {string}
     * @memberof FilterListBean
     */
    name: string;
    /**
     * Type of Filter list
     * @type {string}
     * @memberof FilterListBean
     */
    filterType: FilterListBean.FilterTypeEnum;
    /**
     * Mode of Filter list
     * @type {string}
     * @memberof FilterListBean
     */
    filterMode: FilterListBean.FilterModeEnum;
    /**
     * List of filter data
     * @type {string}
     * @memberof FilterListBean
     */
    data?: string;
}

/**
 * @export
 * @namespace FilterListBean
 */
export namespace FilterListBean {
    /**
     * @export
     * @enum {string}
     */
    export enum FilterTypeEnum {
        Domain = <any> 'Domain',
        UserID = <any> 'UserID',
        IP = <any> 'IP'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FilterModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
}
/**
 * Suitable country list
 * @export
 * @interface GeoBean
 */
export interface GeoBean {
    /**
     * 
     * @type {string}
     * @memberof GeoBean
     */
    country?: string;
    /**
     * 
     * @type {Array<RegionBean>}
     * @memberof GeoBean
     */
    loadedRegions?: Array<RegionBean>;
    /**
     * 
     * @type {string}
     * @memberof GeoBean
     */
    region?: string;
    /**
     * 
     * @type {Array<CityBean>}
     * @memberof GeoBean
     */
    loadedCities?: Array<CityBean>;
    /**
     * 
     * @type {string}
     * @memberof GeoBean
     */
    city?: string;
}
/**
 * 
 * @export
 * @interface IabCategoryBean
 */
export interface IabCategoryBean {
    /**
     * 
     * @type {number}
     * @memberof IabCategoryBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IabCategoryBean
     */
    parentId?: number;
    /**
     * 
     * @type {string}
     * @memberof IabCategoryBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IabCategoryBean
     */
    code?: string;
}
/**
 * 
 * @export
 * @interface ItemResponseAccountBeanObject
 */
export interface ItemResponseAccountBeanObject {
    /**
     * 
     * @type {AccountBean}
     * @memberof ItemResponseAccountBeanObject
     */
    data?: AccountBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAccountBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdGroupBeanObject
 */
export interface ItemResponseAdGroupBeanObject {
    /**
     * 
     * @type {AdGroupBean}
     * @memberof ItemResponseAdGroupBeanObject
     */
    data?: AdGroupBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdGroupBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdSizeBeanObject
 */
export interface ItemResponseAdSizeBeanObject {
    /**
     * 
     * @type {AdSizeBean}
     * @memberof ItemResponseAdSizeBeanObject
     */
    data?: AdSizeBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdSizeBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdvertiserBeanObject
 */
export interface ItemResponseAdvertiserBeanObject {
    /**
     * 
     * @type {AdvertiserBean}
     * @memberof ItemResponseAdvertiserBeanObject
     */
    data?: AdvertiserBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdvertiserBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCampaignBeanObject
 */
export interface ItemResponseCampaignBeanObject {
    /**
     * 
     * @type {CampaignBean}
     * @memberof ItemResponseCampaignBeanObject
     */
    data?: CampaignBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCampaignBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCreativeBeanObject
 */
export interface ItemResponseCreativeBeanObject {
    /**
     * 
     * @type {CreativeBean}
     * @memberof ItemResponseCreativeBeanObject
     */
    data?: CreativeBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCreativeBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseFilterListBeanObject
 */
export interface ItemResponseFilterListBeanObject {
    /**
     * 
     * @type {FilterListBean}
     * @memberof ItemResponseFilterListBeanObject
     */
    data?: FilterListBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseFilterListBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseListObject
 */
export interface ItemResponseListObject {
    /**
     * 
     * @type {Array<any>}
     * @memberof ItemResponseListObject
     */
    data?: Array<any>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseListObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseLogBeanObject
 */
export interface ItemResponseLogBeanObject {
    /**
     * 
     * @type {LogBean}
     * @memberof ItemResponseLogBeanObject
     */
    data?: LogBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseLogBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseMediaAgencyBeanObject
 */
export interface ItemResponseMediaAgencyBeanObject {
    /**
     * 
     * @type {MediaAgencyBean}
     * @memberof ItemResponseMediaAgencyBeanObject
     */
    data?: MediaAgencyBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseMediaAgencyBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseReportBeanObject
 */
export interface ItemResponseReportBeanObject {
    /**
     * 
     * @type {ReportBean}
     * @memberof ItemResponseReportBeanObject
     */
    data?: ReportBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseReportBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSspBeanObject
 */
export interface ItemResponseSspBeanObject {
    /**
     * 
     * @type {SspBean}
     * @memberof ItemResponseSspBeanObject
     */
    data?: SspBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSspBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseStringObject
 */
export interface ItemResponseStringObject {
    /**
     * 
     * @type {string}
     * @memberof ItemResponseStringObject
     */
    data?: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseStringObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseUUIDObject
 */
export interface ItemResponseUUIDObject {
    /**
     * 
     * @type {string}
     * @memberof ItemResponseUUIDObject
     */
    data?: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseUUIDObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface KeyFilterClause
 */
export interface KeyFilterClause {
    /**
     * 
     * @type {string}
     * @memberof KeyFilterClause
     */
    type?: KeyFilterClause.TypeEnum;
    /**
     * 
     * @type {any}
     * @memberof KeyFilterClause
     */
    value?: any;
}

/**
 * @export
 * @namespace KeyFilterClause
 */
export namespace KeyFilterClause {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        In = <any> 'in',
        Between = <any> 'between',
        Equals = <any> 'equals',
        NotEquals = <any> 'notEquals'
    }
}
/**
 * 
 * @export
 * @interface LanguageBean
 */
export interface LanguageBean {
    /**
     * 
     * @type {string}
     * @memberof LanguageBean
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface ListPagination
 */
export interface ListPagination {
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface ListResponseAccountBean
 */
export interface ListResponseAccountBean {
    /**
     * 
     * @type {Array<ItemResponseAccountBeanObject>}
     * @memberof ListResponseAccountBean
     */
    data?: Array<ItemResponseAccountBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAccountBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAdGroupBean
 */
export interface ListResponseAdGroupBean {
    /**
     * 
     * @type {Array<ItemResponseAdGroupBeanObject>}
     * @memberof ListResponseAdGroupBean
     */
    data?: Array<ItemResponseAdGroupBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdGroupBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAdSizeBean
 */
export interface ListResponseAdSizeBean {
    /**
     * 
     * @type {Array<ItemResponseAdSizeBeanObject>}
     * @memberof ListResponseAdSizeBean
     */
    data?: Array<ItemResponseAdSizeBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdSizeBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAdvertiserBean
 */
export interface ListResponseAdvertiserBean {
    /**
     * 
     * @type {Array<ItemResponseAdvertiserBeanObject>}
     * @memberof ListResponseAdvertiserBean
     */
    data?: Array<ItemResponseAdvertiserBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdvertiserBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseCampaignBean
 */
export interface ListResponseCampaignBean {
    /**
     * 
     * @type {Array<ItemResponseCampaignBeanObject>}
     * @memberof ListResponseCampaignBean
     */
    data?: Array<ItemResponseCampaignBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseCampaignBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseCreativeBean
 */
export interface ListResponseCreativeBean {
    /**
     * 
     * @type {Array<ItemResponseCreativeBeanObject>}
     * @memberof ListResponseCreativeBean
     */
    data?: Array<ItemResponseCreativeBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseCreativeBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseFilterListBean
 */
export interface ListResponseFilterListBean {
    /**
     * 
     * @type {Array<ItemResponseFilterListBeanObject>}
     * @memberof ListResponseFilterListBean
     */
    data?: Array<ItemResponseFilterListBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseFilterListBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseLogBean
 */
export interface ListResponseLogBean {
    /**
     * 
     * @type {Array<ItemResponseLogBeanObject>}
     * @memberof ListResponseLogBean
     */
    data?: Array<ItemResponseLogBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseLogBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseMediaAgencyBean
 */
export interface ListResponseMediaAgencyBean {
    /**
     * 
     * @type {Array<ItemResponseMediaAgencyBeanObject>}
     * @memberof ListResponseMediaAgencyBean
     */
    data?: Array<ItemResponseMediaAgencyBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseMediaAgencyBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseSspBean
 */
export interface ListResponseSspBean {
    /**
     * 
     * @type {Array<ItemResponseSspBeanObject>}
     * @memberof ListResponseSspBean
     */
    data?: Array<ItemResponseSspBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSspBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface LogBean
 */
export interface LogBean {
    /**
     * 
     * @type {number}
     * @memberof LogBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LogBean
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof LogBean
     */
    account?: number;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    prevValue?: string;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    currentValue?: string;
    /**
     * 
     * @type {Date}
     * @memberof LogBean
     */
    date?: Date;
}
/**
 * 
 * @export
 * @interface MediaAgencyBean
 */
export interface MediaAgencyBean {
    /**
     * 
     * @type {number}
     * @memberof MediaAgencyBean
     */
    id?: number;
    /**
     * Name of the media agency.
     * @type {string}
     * @memberof MediaAgencyBean
     */
    name: string;
    /**
     * Country of the media agency
     * @type {string}
     * @memberof MediaAgencyBean
     */
    countryId: string;
    /**
     * The web address associated with the media agency.
     * @type {string}
     * @memberof MediaAgencyBean
     */
    domain?: string;
    /**
     * Description of media agency.
     * @type {string}
     * @memberof MediaAgencyBean
     */
    description?: string;
    /**
     * Media agency status
     * @type {boolean}
     * @memberof MediaAgencyBean
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface NativeBean
 */
export interface NativeBean {
    /**
     * Native title
     * @type {string}
     * @memberof NativeBean
     */
    title: string;
    /**
     * Native icon
     * @type {string}
     * @memberof NativeBean
     */
    icon?: string;
    /**
     * Native main image
     * @type {string}
     * @memberof NativeBean
     */
    banner?: string;
    /**
     * Call to action
     * @type {string}
     * @memberof NativeBean
     */
    cta?: string;
    /**
     * Sponsored by
     * @type {string}
     * @memberof NativeBean
     */
    sponsored?: string;
    /**
     * Native description
     * @type {string}
     * @memberof NativeBean
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface RegionBean
 */
export interface RegionBean {
    /**
     * 
     * @type {string}
     * @memberof RegionBean
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof RegionBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface ReportBean
 */
export interface ReportBean {
    /**
     * 
     * @type {number}
     * @memberof ReportBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportBean
     */
    error?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ReportBean
     */
    totalValues?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ReportBean
     */
    totalLines?: number;
}
/**
 * 
 * @export
 * @interface ReportRequestParameters
 */
export interface ReportRequestParameters {
    /**
     * 
     * @type {Array<EventReportKeyColumnDescription>}
     * @memberof ReportRequestParameters
     */
    keyColumns?: Array<EventReportKeyColumnDescription>;
    /**
     * 
     * @type {Array<EventReportValueColumnDescription>}
     * @memberof ReportRequestParameters
     */
    valueColumns?: Array<EventReportValueColumnDescription>;
}
/**
 * 
 * @export
 * @interface SspBean
 */
export interface SspBean {
    /**
     * 
     * @type {number}
     * @memberof SspBean
     */
    id?: number;
    /**
     * Name of SSP
     * @type {string}
     * @memberof SspBean
     */
    name: string;
    /**
     * Endpoint of SSP
     * @type {string}
     * @memberof SspBean
     */
    endpoint: string;
    /**
     * Type of SSP. Simple OpenRTB or SSP specific
     * @type {string}
     * @memberof SspBean
     */
    sspType: SspBean.SspTypeEnum;
    /**
     * Active
     * @type {boolean}
     * @memberof SspBean
     */
    active: boolean;
    /**
     * API key for SSP stat report
     * @type {string}
     * @memberof SspBean
     */
    apiKey?: string;
    /**
     * Consent validation enabled
     * @type {boolean}
     * @memberof SspBean
     */
    consentValidation: boolean;
    /**
     * Type of billing
     * @type {string}
     * @memberof SspBean
     */
    billingType: SspBean.BillingTypeEnum;
}

/**
 * @export
 * @namespace SspBean
 */
export namespace SspBean {
    /**
     * @export
     * @enum {string}
     */
    export enum SspTypeEnum {
        OpenRTB = <any> 'OpenRTB'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BillingTypeEnum {
        Adm = <any> 'Adm',
        Win = <any> 'Win',
        Burl = <any> 'Burl'
    }
}
/**
 * 
 * @export
 * @interface SspReportDay
 */
export interface SspReportDay {
    /**
     * 
     * @type {number}
     * @memberof SspReportDay
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof SspReportDay
     */
    cost?: number;
    /**
     * 
     * @type {number}
     * @memberof SspReportDay
     */
    bids?: number;
}
/**
 * 
 * @export
 * @interface TimeZoneBean
 */
export interface TimeZoneBean {
    /**
     * 
     * @type {string}
     * @memberof TimeZoneBean
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeZoneBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TimeZoneBean
     */
    rawOffset?: number;
}
/**
 * 
 * @export
 * @interface ValueFilterClause
 */
export interface ValueFilterClause {
    /**
     * 
     * @type {string}
     * @memberof ValueFilterClause
     */
    type?: ValueFilterClause.TypeEnum;
    /**
     * 
     * @type {any}
     * @memberof ValueFilterClause
     */
    value?: any;
}

/**
 * @export
 * @namespace ValueFilterClause
 */
export namespace ValueFilterClause {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Le = <any> 'le',
        Ge = <any> 'ge',
        Between = <any> 'between'
    }
}
/**
 * AccountControllerApi - fetch parameter creator
 * @export
 */
export const AccountControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Account by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling account.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user properties by logged in account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options: any = {}): FetchArgs {
            const localVarPath = `/api/accountProps`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options: any = {}): FetchArgs {
            const localVarPath = `/api/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Account
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAccount.');
            }
            const localVarPath = `/api/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Account by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAccount.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit Account by ID
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAccount.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAccount.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Account by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).account(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user properties by logged in account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).accountProps(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAccountBean> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).accounts(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Account
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).createAccount(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Account by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).deleteAccount(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Edit Account by ID
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).editAccount(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get Account by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options?: any) {
            return AccountControllerApiFp(configuration).account(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user properties by logged in account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options?: any) {
            return AccountControllerApiFp(configuration).accountProps(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options?: any) {
            return AccountControllerApiFp(configuration).accounts(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Account
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any) {
            return AccountControllerApiFp(configuration).createAccount(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Account by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any) {
            return AccountControllerApiFp(configuration).deleteAccount(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Edit Account by ID
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any) {
            return AccountControllerApiFp(configuration).editAccount(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Account by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public account(id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).account(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user properties by logged in account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public accountProps(options?: any) {
        return AccountControllerApiFp(this.configuration).accountProps(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public accounts(options?: any) {
        return AccountControllerApiFp(this.configuration).accounts(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Account
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public createAccount(body: AccountBean, options?: any) {
        return AccountControllerApiFp(this.configuration).createAccount(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Account by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public deleteAccount(id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).deleteAccount(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Edit Account by ID
     * @param {AccountBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public editAccount(body: AccountBean, id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).editAccount(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdGroupControllerApi - fetch parameter creator
 * @export
 */
export const AdGroupControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Ad Group by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adGroup.');
            }
            const localVarPath = `/api/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Ad Groups
         * @param {string} [search] 
         * @param {number} [campaign] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupList(search?: string, campaign?: number, status?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/ad-group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Ad Group
         * @param {AdGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdGroup(body: AdGroupBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdGroup.');
            }
            const localVarPath = `/api/ad-group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdGroupBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Ad Group by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdGroup.');
            }
            const localVarPath = `/api/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Ad Group by ID
         * @param {AdGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdGroup(body: AdGroupBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdGroup.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdGroup.');
            }
            const localVarPath = `/api/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdGroupBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdGroupControllerApi - functional programming interface
 * @export
 */
export const AdGroupControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Ad Group by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdGroupBeanObject> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).adGroup(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Ad Groups
         * @param {string} [search] 
         * @param {number} [campaign] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupList(search?: string, campaign?: number, status?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdGroupBean> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).adGroupList(search, campaign, status, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Ad Group
         * @param {AdGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdGroup(body: AdGroupBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdGroupBeanObject> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).createAdGroup(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Ad Group by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).deleteAdGroup(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Ad Group by ID
         * @param {AdGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdGroup(body: AdGroupBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdGroupBeanObject> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).editAdGroup(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdGroupControllerApi - factory interface
 * @export
 */
export const AdGroupControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get Ad Group by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroup(id: number, options?: any) {
            return AdGroupControllerApiFp(configuration).adGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Ad Groups
         * @param {string} [search] 
         * @param {number} [campaign] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupList(search?: string, campaign?: number, status?: string, options?: any) {
            return AdGroupControllerApiFp(configuration).adGroupList(search, campaign, status, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Ad Group
         * @param {AdGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdGroup(body: AdGroupBean, options?: any) {
            return AdGroupControllerApiFp(configuration).createAdGroup(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Ad Group by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdGroup(id: number, options?: any) {
            return AdGroupControllerApiFp(configuration).deleteAdGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Ad Group by ID
         * @param {AdGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdGroup(body: AdGroupBean, id: number, options?: any) {
            return AdGroupControllerApiFp(configuration).editAdGroup(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AdGroupControllerApi - object-oriented interface
 * @export
 * @class AdGroupControllerApi
 * @extends {BaseAPI}
 */
export class AdGroupControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Ad Group by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public adGroup(id: number, options?: any) {
        return AdGroupControllerApiFp(this.configuration).adGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Ad Groups
     * @param {string} [search] 
     * @param {number} [campaign] 
     * @param {string} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public adGroupList(search?: string, campaign?: number, status?: string, options?: any) {
        return AdGroupControllerApiFp(this.configuration).adGroupList(search, campaign, status, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Ad Group
     * @param {AdGroupBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public createAdGroup(body: AdGroupBean, options?: any) {
        return AdGroupControllerApiFp(this.configuration).createAdGroup(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Ad Group by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public deleteAdGroup(id: number, options?: any) {
        return AdGroupControllerApiFp(this.configuration).deleteAdGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Ad Group by ID
     * @param {AdGroupBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public editAdGroup(body: AdGroupBean, id: number, options?: any) {
        return AdGroupControllerApiFp(this.configuration).editAdGroup(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdSizeControllerApi - fetch parameter creator
 * @export
 */
export const AdSizeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Ad Size by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSize(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adSize.');
            }
            const localVarPath = `/api/ad-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Ad Sizes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSizeList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/ad-size`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Ad Size
         * @param {AdSizeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdSize(body: AdSizeBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdSize.');
            }
            const localVarPath = `/api/ad-size`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdSizeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Ad Size by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdSize(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdSize.');
            }
            const localVarPath = `/api/ad-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Ad Size by ID
         * @param {AdSizeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdSize(body: AdSizeBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdSize.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdSize.');
            }
            const localVarPath = `/api/ad-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdSizeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdSizeControllerApi - functional programming interface
 * @export
 */
export const AdSizeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Ad Size by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSize(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdSizeBeanObject> {
            const localVarFetchArgs = AdSizeControllerApiFetchParamCreator(configuration).adSize(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Ad Sizes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSizeList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdSizeBean> {
            const localVarFetchArgs = AdSizeControllerApiFetchParamCreator(configuration).adSizeList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Ad Size
         * @param {AdSizeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdSize(body: AdSizeBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdSizeBeanObject> {
            const localVarFetchArgs = AdSizeControllerApiFetchParamCreator(configuration).createAdSize(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Ad Size by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdSize(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdSizeControllerApiFetchParamCreator(configuration).deleteAdSize(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Ad Size by ID
         * @param {AdSizeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdSize(body: AdSizeBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdSizeBeanObject> {
            const localVarFetchArgs = AdSizeControllerApiFetchParamCreator(configuration).editAdSize(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdSizeControllerApi - factory interface
 * @export
 */
export const AdSizeControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get Ad Size by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSize(id: number, options?: any) {
            return AdSizeControllerApiFp(configuration).adSize(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Ad Sizes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSizeList(search?: string, options?: any) {
            return AdSizeControllerApiFp(configuration).adSizeList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Ad Size
         * @param {AdSizeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdSize(body: AdSizeBean, options?: any) {
            return AdSizeControllerApiFp(configuration).createAdSize(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Ad Size by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdSize(id: number, options?: any) {
            return AdSizeControllerApiFp(configuration).deleteAdSize(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Ad Size by ID
         * @param {AdSizeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdSize(body: AdSizeBean, id: number, options?: any) {
            return AdSizeControllerApiFp(configuration).editAdSize(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AdSizeControllerApi - object-oriented interface
 * @export
 * @class AdSizeControllerApi
 * @extends {BaseAPI}
 */
export class AdSizeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Ad Size by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdSizeControllerApi
     */
    public adSize(id: number, options?: any) {
        return AdSizeControllerApiFp(this.configuration).adSize(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Ad Sizes
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdSizeControllerApi
     */
    public adSizeList(search?: string, options?: any) {
        return AdSizeControllerApiFp(this.configuration).adSizeList(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Ad Size
     * @param {AdSizeBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdSizeControllerApi
     */
    public createAdSize(body: AdSizeBean, options?: any) {
        return AdSizeControllerApiFp(this.configuration).createAdSize(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Ad Size by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdSizeControllerApi
     */
    public deleteAdSize(id: number, options?: any) {
        return AdSizeControllerApiFp(this.configuration).deleteAdSize(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Ad Size by ID
     * @param {AdSizeBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdSizeControllerApi
     */
    public editAdSize(body: AdSizeBean, id: number, options?: any) {
        return AdSizeControllerApiFp(this.configuration).editAdSize(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdvertiserControllerApi - fetch parameter creator
 * @export
 */
export const AdvertiserControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Advertiser
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAdvertiser(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling activateAdvertiser.');
            }
            const localVarPath = `/api/advertiser/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Advertiser by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiser(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling advertiser.');
            }
            const localVarPath = `/api/advertiser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Advertisers
         * @param {string} [search] 
         * @param {number} [mediaAgency] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserList(search?: string, mediaAgency?: number, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/advertisers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (mediaAgency !== undefined) {
                localVarQueryParameter['mediaAgency'] = mediaAgency;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Advertiser
         * @param {AdvertiserBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdvertiser(body: AdvertiserBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdvertiser.');
            }
            const localVarPath = `/api/advertiser`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdvertiserBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Advertiser by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdvertiser(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdvertiser.');
            }
            const localVarPath = `/api/advertiser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Advertiser by ID
         * @param {AdvertiserBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdvertiser(body: AdvertiserBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdvertiser.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdvertiser.');
            }
            const localVarPath = `/api/advertiser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdvertiserBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvertiserControllerApi - functional programming interface
 * @export
 */
export const AdvertiserControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Advertiser
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAdvertiser(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).activateAdvertiser(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Advertiser by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiser(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdvertiserBeanObject> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).advertiser(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Advertisers
         * @param {string} [search] 
         * @param {number} [mediaAgency] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserList(search?: string, mediaAgency?: number, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdvertiserBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).advertiserList(search, mediaAgency, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Advertiser
         * @param {AdvertiserBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdvertiser(body: AdvertiserBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdvertiserBeanObject> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).createAdvertiser(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Advertiser by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdvertiser(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).deleteAdvertiser(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Advertiser by ID
         * @param {AdvertiserBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdvertiser(body: AdvertiserBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdvertiserBeanObject> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).editAdvertiser(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdvertiserControllerApi - factory interface
 * @export
 */
export const AdvertiserControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Advertiser
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAdvertiser(id: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).activateAdvertiser(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Advertiser by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiser(id: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).advertiser(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Advertisers
         * @param {string} [search] 
         * @param {number} [mediaAgency] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserList(search?: string, mediaAgency?: number, active?: boolean, options?: any) {
            return AdvertiserControllerApiFp(configuration).advertiserList(search, mediaAgency, active, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Advertiser
         * @param {AdvertiserBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdvertiser(body: AdvertiserBean, options?: any) {
            return AdvertiserControllerApiFp(configuration).createAdvertiser(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Advertiser by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdvertiser(id: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).deleteAdvertiser(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Advertiser by ID
         * @param {AdvertiserBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdvertiser(body: AdvertiserBean, id: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).editAdvertiser(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AdvertiserControllerApi - object-oriented interface
 * @export
 * @class AdvertiserControllerApi
 * @extends {BaseAPI}
 */
export class AdvertiserControllerApi extends BaseAPI {
    /**
     * 
     * @summary Activate/Deactivate Advertiser
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public activateAdvertiser(id: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).activateAdvertiser(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Advertiser by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public advertiser(id: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).advertiser(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Advertisers
     * @param {string} [search] 
     * @param {number} [mediaAgency] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public advertiserList(search?: string, mediaAgency?: number, active?: boolean, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).advertiserList(search, mediaAgency, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Advertiser
     * @param {AdvertiserBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public createAdvertiser(body: AdvertiserBean, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).createAdvertiser(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Advertiser by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public deleteAdvertiser(id: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).deleteAdvertiser(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Advertiser by ID
     * @param {AdvertiserBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public editAdvertiser(body: AdvertiserBean, id: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).editAdvertiser(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * CampaignControllerApi - fetch parameter creator
 * @export
 */
export const CampaignControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get campaign by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaign(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling campaign.');
            }
            const localVarPath = `/api/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Campaigns
         * @param {string} [search] 
         * @param {number} [advertiser] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignList(search?: string, advertiser?: number, status?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/campaign`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (advertiser !== undefined) {
                localVarQueryParameter['advertiser'] = advertiser;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create campaign
         * @param {CampaignBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(body: CampaignBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCampaign.');
            }
            const localVarPath = `/api/campaign`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CampaignBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaign(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCampaign.');
            }
            const localVarPath = `/api/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit campaign by ID
         * @param {CampaignBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCampaign(body: CampaignBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editCampaign.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editCampaign.');
            }
            const localVarPath = `/api/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CampaignBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignControllerApi - functional programming interface
 * @export
 */
export const CampaignControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get campaign by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaign(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCampaignBeanObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaign(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Campaigns
         * @param {string} [search] 
         * @param {number} [advertiser] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignList(search?: string, advertiser?: number, status?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCampaignBean> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaignList(search, advertiser, status, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create campaign
         * @param {CampaignBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(body: CampaignBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCampaignBeanObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).createCampaign(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaign(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).deleteCampaign(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Edit campaign by ID
         * @param {CampaignBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCampaign(body: CampaignBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCampaignBeanObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).editCampaign(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CampaignControllerApi - factory interface
 * @export
 */
export const CampaignControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get campaign by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaign(id: number, options?: any) {
            return CampaignControllerApiFp(configuration).campaign(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Campaigns
         * @param {string} [search] 
         * @param {number} [advertiser] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignList(search?: string, advertiser?: number, status?: string, options?: any) {
            return CampaignControllerApiFp(configuration).campaignList(search, advertiser, status, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create campaign
         * @param {CampaignBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(body: CampaignBean, options?: any) {
            return CampaignControllerApiFp(configuration).createCampaign(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaign(id: number, options?: any) {
            return CampaignControllerApiFp(configuration).deleteCampaign(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Edit campaign by ID
         * @param {CampaignBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCampaign(body: CampaignBean, id: number, options?: any) {
            return CampaignControllerApiFp(configuration).editCampaign(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * CampaignControllerApi - object-oriented interface
 * @export
 * @class CampaignControllerApi
 * @extends {BaseAPI}
 */
export class CampaignControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get campaign by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaign(id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaign(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Campaigns
     * @param {string} [search] 
     * @param {number} [advertiser] 
     * @param {string} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaignList(search?: string, advertiser?: number, status?: string, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaignList(search, advertiser, status, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create campaign
     * @param {CampaignBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public createCampaign(body: CampaignBean, options?: any) {
        return CampaignControllerApiFp(this.configuration).createCampaign(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete campaign
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public deleteCampaign(id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).deleteCampaign(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Edit campaign by ID
     * @param {CampaignBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public editCampaign(body: CampaignBean, id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).editCampaign(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * CreativeControllerApi - fetch parameter creator
 * @export
 */
export const CreativeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Creative
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCreative(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling activateCreative.');
            }
            const localVarPath = `/api/creative/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Creatives bulk
         * @param {string} bean 
         * @param {Array<number>} sizes 
         * @param {CreativeBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulk(bean: string, sizes: Array<number>, body?: CreativeBulkBody, options: any = {}): FetchArgs {
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling createBulk.');
            }
            // verify required parameter 'sizes' is not null or undefined
            if (sizes === null || sizes === undefined) {
                throw new RequiredError('sizes','Required parameter sizes was null or undefined when calling createBulk.');
            }
            const localVarPath = `/api/creative/bulk`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            if (sizes) {
                localVarQueryParameter['sizes'] = sizes;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreativeBulkBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Creative
         * @param {string} bean 
         * @param {ApiCreativeBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(bean: string, body?: ApiCreativeBody, options: any = {}): FetchArgs {
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling createCreative.');
            }
            const localVarPath = `/api/creative`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ApiCreativeBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Creative by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creative(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling creative.');
            }
            const localVarPath = `/api/creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Creatives
         * @param {string} [search] 
         * @param {number} [adGroup] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(search?: string, adGroup?: number, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/creative`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (adGroup !== undefined) {
                localVarQueryParameter['adGroup'] = adGroup;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Creatives by AdGroup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeListByAdGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling creativeListByAdGroup.');
            }
            const localVarPath = `/api/creative/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Creative by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCreative.');
            }
            const localVarPath = `/api/creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Creative by ID
         * @param {number} id 
         * @param {string} bean 
         * @param {CreativeIdBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(id: number, bean: string, body?: CreativeIdBody, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editCreative.');
            }
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling editCreative.');
            }
            const localVarPath = `/api/creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreativeIdBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreativeControllerApi - functional programming interface
 * @export
 */
export const CreativeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Creative
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCreative(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).activateCreative(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Creatives bulk
         * @param {string} bean 
         * @param {Array<number>} sizes 
         * @param {CreativeBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulk(bean: string, sizes: Array<number>, body?: CreativeBulkBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseListObject> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).createBulk(bean, sizes, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Creative
         * @param {string} bean 
         * @param {ApiCreativeBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(bean: string, body?: ApiCreativeBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCreativeBeanObject> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).createCreative(bean, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Creative by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creative(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCreativeBeanObject> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).creative(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Creatives
         * @param {string} [search] 
         * @param {number} [adGroup] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(search?: string, adGroup?: number, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCreativeBean> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).creativeList(search, adGroup, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Creatives by AdGroup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeListByAdGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCreativeBean> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).creativeListByAdGroup(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Creative by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).deleteCreative(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Creative by ID
         * @param {number} id 
         * @param {string} bean 
         * @param {CreativeIdBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(id: number, bean: string, body?: CreativeIdBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCreativeBeanObject> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).editCreative(id, bean, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CreativeControllerApi - factory interface
 * @export
 */
export const CreativeControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Creative
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCreative(id: number, options?: any) {
            return CreativeControllerApiFp(configuration).activateCreative(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Creatives bulk
         * @param {string} bean 
         * @param {Array<number>} sizes 
         * @param {CreativeBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulk(bean: string, sizes: Array<number>, body?: CreativeBulkBody, options?: any) {
            return CreativeControllerApiFp(configuration).createBulk(bean, sizes, body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Creative
         * @param {string} bean 
         * @param {ApiCreativeBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(bean: string, body?: ApiCreativeBody, options?: any) {
            return CreativeControllerApiFp(configuration).createCreative(bean, body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Creative by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creative(id: number, options?: any) {
            return CreativeControllerApiFp(configuration).creative(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Creatives
         * @param {string} [search] 
         * @param {number} [adGroup] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(search?: string, adGroup?: number, active?: boolean, options?: any) {
            return CreativeControllerApiFp(configuration).creativeList(search, adGroup, active, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Creatives by AdGroup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeListByAdGroup(id: number, options?: any) {
            return CreativeControllerApiFp(configuration).creativeListByAdGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Creative by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options?: any) {
            return CreativeControllerApiFp(configuration).deleteCreative(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Creative by ID
         * @param {number} id 
         * @param {string} bean 
         * @param {CreativeIdBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(id: number, bean: string, body?: CreativeIdBody, options?: any) {
            return CreativeControllerApiFp(configuration).editCreative(id, bean, body, options)(fetch, basePath);
        },
    };
};

/**
 * CreativeControllerApi - object-oriented interface
 * @export
 * @class CreativeControllerApi
 * @extends {BaseAPI}
 */
export class CreativeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Activate/Deactivate Creative
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public activateCreative(id: number, options?: any) {
        return CreativeControllerApiFp(this.configuration).activateCreative(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Creatives bulk
     * @param {string} bean 
     * @param {Array<number>} sizes 
     * @param {CreativeBulkBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public createBulk(bean: string, sizes: Array<number>, body?: CreativeBulkBody, options?: any) {
        return CreativeControllerApiFp(this.configuration).createBulk(bean, sizes, body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Creative
     * @param {string} bean 
     * @param {ApiCreativeBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public createCreative(bean: string, body?: ApiCreativeBody, options?: any) {
        return CreativeControllerApiFp(this.configuration).createCreative(bean, body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Creative by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public creative(id: number, options?: any) {
        return CreativeControllerApiFp(this.configuration).creative(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Creatives
     * @param {string} [search] 
     * @param {number} [adGroup] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public creativeList(search?: string, adGroup?: number, active?: boolean, options?: any) {
        return CreativeControllerApiFp(this.configuration).creativeList(search, adGroup, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Creatives by AdGroup
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public creativeListByAdGroup(id: number, options?: any) {
        return CreativeControllerApiFp(this.configuration).creativeListByAdGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Creative by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public deleteCreative(id: number, options?: any) {
        return CreativeControllerApiFp(this.configuration).deleteCreative(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Creative by ID
     * @param {number} id 
     * @param {string} bean 
     * @param {CreativeIdBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public editCreative(id: number, bean: string, body?: CreativeIdBody, options?: any) {
        return CreativeControllerApiFp(this.configuration).editCreative(id, bean, body, options)(this.fetch, this.basePath);
    }

}
/**
 * DictionariesControllerApi - fetch parameter creator
 * @export
 */
export const DictionariesControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get city list by region
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities(code: string, options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling cities.');
            }
            const localVarPath = `/api/city/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get country list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options: any = {}): FetchArgs {
            const localVarPath = `/api/country`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Device Type list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceTypes(options: any = {}): FetchArgs {
            const localVarPath = `/api/device-types`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of IAB categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options: any = {}): FetchArgs {
            const localVarPath = `/api/iab-category`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options: any = {}): FetchArgs {
            const localVarPath = `/api/language`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get platform list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platforms(options: any = {}): FetchArgs {
            const localVarPath = `/api/platform`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get region list by country
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regions(code: string, options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling regions.');
            }
            const localVarPath = `/api/region/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of timezones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options: any = {}): FetchArgs {
            const localVarPath = `/api/timezone`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesControllerApi - functional programming interface
 * @export
 */
export const DictionariesControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get city list by region
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities(code: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CityBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).cities(code, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get country list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CountryBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).countries(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Device Type list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceTypes(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DeviceTypeBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).deviceTypes(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get list of IAB categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<IabCategoryBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).iabCategories(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get list of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LanguageBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).language(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get platform list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platforms(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).platforms(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get region list by country
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regions(code: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RegionBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).regions(code, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get list of timezones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TimeZoneBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).timezone(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DictionariesControllerApi - factory interface
 * @export
 */
export const DictionariesControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get city list by region
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities(code: string, options?: any) {
            return DictionariesControllerApiFp(configuration).cities(code, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get country list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: any) {
            return DictionariesControllerApiFp(configuration).countries(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Device Type list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceTypes(options?: any) {
            return DictionariesControllerApiFp(configuration).deviceTypes(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get list of IAB categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options?: any) {
            return DictionariesControllerApiFp(configuration).iabCategories(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get list of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options?: any) {
            return DictionariesControllerApiFp(configuration).language(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get platform list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platforms(options?: any) {
            return DictionariesControllerApiFp(configuration).platforms(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get region list by country
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regions(code: string, options?: any) {
            return DictionariesControllerApiFp(configuration).regions(code, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get list of timezones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options?: any) {
            return DictionariesControllerApiFp(configuration).timezone(options)(fetch, basePath);
        },
    };
};

/**
 * DictionariesControllerApi - object-oriented interface
 * @export
 * @class DictionariesControllerApi
 * @extends {BaseAPI}
 */
export class DictionariesControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get city list by region
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public cities(code: string, options?: any) {
        return DictionariesControllerApiFp(this.configuration).cities(code, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get country list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public countries(options?: any) {
        return DictionariesControllerApiFp(this.configuration).countries(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Device Type list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public deviceTypes(options?: any) {
        return DictionariesControllerApiFp(this.configuration).deviceTypes(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get list of IAB categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public iabCategories(options?: any) {
        return DictionariesControllerApiFp(this.configuration).iabCategories(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get list of languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public language(options?: any) {
        return DictionariesControllerApiFp(this.configuration).language(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get platform list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public platforms(options?: any) {
        return DictionariesControllerApiFp(this.configuration).platforms(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get region list by country
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public regions(code: string, options?: any) {
        return DictionariesControllerApiFp(this.configuration).regions(code, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get list of timezones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public timezone(options?: any) {
        return DictionariesControllerApiFp(this.configuration).timezone(options)(this.fetch, this.basePath);
    }

}
/**
 * FilterListControllerApi - fetch parameter creator
 * @export
 */
export const FilterListControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Filter list
         * @param {FilterListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterList(body: FilterListBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createFilterList.');
            }
            const localVarPath = `/api/filter-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FilterListBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Filter list by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterList(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteFilterList.');
            }
            const localVarPath = `/api/filter-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Filter list by ID
         * @param {FilterListBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFilterList(body: FilterListBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editFilterList.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editFilterList.');
            }
            const localVarPath = `/api/filter-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FilterListBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Filter list by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterList(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling filterList.');
            }
            const localVarPath = `/api/filter-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Filter lists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterLists(options: any = {}): FetchArgs {
            const localVarPath = `/api/filter-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilterListControllerApi - functional programming interface
 * @export
 */
export const FilterListControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Filter list
         * @param {FilterListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterList(body: FilterListBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseFilterListBeanObject> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).createFilterList(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Filter list by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterList(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).deleteFilterList(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Filter list by ID
         * @param {FilterListBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFilterList(body: FilterListBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseFilterListBeanObject> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).editFilterList(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Filter list by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterList(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseFilterListBeanObject> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).filterList(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Filter lists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterLists(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseFilterListBean> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).filterLists(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FilterListControllerApi - factory interface
 * @export
 */
export const FilterListControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new Filter list
         * @param {FilterListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterList(body: FilterListBean, options?: any) {
            return FilterListControllerApiFp(configuration).createFilterList(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Filter list by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterList(id: number, options?: any) {
            return FilterListControllerApiFp(configuration).deleteFilterList(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Filter list by ID
         * @param {FilterListBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFilterList(body: FilterListBean, id: number, options?: any) {
            return FilterListControllerApiFp(configuration).editFilterList(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Filter list by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterList(id: number, options?: any) {
            return FilterListControllerApiFp(configuration).filterList(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Filter lists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterLists(options?: any) {
            return FilterListControllerApiFp(configuration).filterLists(options)(fetch, basePath);
        },
    };
};

/**
 * FilterListControllerApi - object-oriented interface
 * @export
 * @class FilterListControllerApi
 * @extends {BaseAPI}
 */
export class FilterListControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Filter list
     * @param {FilterListBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public createFilterList(body: FilterListBean, options?: any) {
        return FilterListControllerApiFp(this.configuration).createFilterList(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Filter list by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public deleteFilterList(id: number, options?: any) {
        return FilterListControllerApiFp(this.configuration).deleteFilterList(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Filter list by ID
     * @param {FilterListBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public editFilterList(body: FilterListBean, id: number, options?: any) {
        return FilterListControllerApiFp(this.configuration).editFilterList(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Filter list by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public filterList(id: number, options?: any) {
        return FilterListControllerApiFp(this.configuration).filterList(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Filter lists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public filterLists(options?: any) {
        return FilterListControllerApiFp(this.configuration).filterLists(options)(this.fetch, this.basePath);
    }

}
/**
 * GeoControllerApi - fetch parameter creator
 * @export
 */
export const GeoControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get geo for AdGroup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdGroupGeo(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAdGroupGeo.');
            }
            const localVarPath = `/api/geo/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get geo for Campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignGeo(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCampaignGeo.');
            }
            const localVarPath = `/api/geo/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeoControllerApi - functional programming interface
 * @export
 */
export const GeoControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get geo for AdGroup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdGroupGeo(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GeoBean>> {
            const localVarFetchArgs = GeoControllerApiFetchParamCreator(configuration).getAdGroupGeo(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get geo for Campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignGeo(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GeoBean>> {
            const localVarFetchArgs = GeoControllerApiFetchParamCreator(configuration).getCampaignGeo(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * GeoControllerApi - factory interface
 * @export
 */
export const GeoControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get geo for AdGroup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdGroupGeo(id: number, options?: any) {
            return GeoControllerApiFp(configuration).getAdGroupGeo(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get geo for Campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignGeo(id: number, options?: any) {
            return GeoControllerApiFp(configuration).getCampaignGeo(id, options)(fetch, basePath);
        },
    };
};

/**
 * GeoControllerApi - object-oriented interface
 * @export
 * @class GeoControllerApi
 * @extends {BaseAPI}
 */
export class GeoControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get geo for AdGroup
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoControllerApi
     */
    public getAdGroupGeo(id: number, options?: any) {
        return GeoControllerApiFp(this.configuration).getAdGroupGeo(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get geo for Campaign
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoControllerApi
     */
    public getCampaignGeo(id: number, options?: any) {
        return GeoControllerApiFp(this.configuration).getCampaignGeo(id, options)(this.fetch, this.basePath);
    }

}
/**
 * LogControllerApi - fetch parameter creator
 * @export
 */
export const LogControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logList(entityType?: string, entityId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogControllerApi - functional programming interface
 * @export
 */
export const LogControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logList(entityType?: string, entityId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseLogBean> {
            const localVarFetchArgs = LogControllerApiFetchParamCreator(configuration).logList(entityType, entityId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * LogControllerApi - factory interface
 * @export
 */
export const LogControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logList(entityType?: string, entityId?: number, options?: any) {
            return LogControllerApiFp(configuration).logList(entityType, entityId, options)(fetch, basePath);
        },
    };
};

/**
 * LogControllerApi - object-oriented interface
 * @export
 * @class LogControllerApi
 * @extends {BaseAPI}
 */
export class LogControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [entityType] 
     * @param {number} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogControllerApi
     */
    public logList(entityType?: string, entityId?: number, options?: any) {
        return LogControllerApiFp(this.configuration).logList(entityType, entityId, options)(this.fetch, this.basePath);
    }

}
/**
 * MediaAgencyControllerApi - fetch parameter creator
 * @export
 */
export const MediaAgencyControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Media Agency
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMediaAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling activateMediaAgency.');
            }
            const localVarPath = `/api/media-agency/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Media Agency
         * @param {MediaAgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediaAgency(body: MediaAgencyBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createMediaAgency.');
            }
            const localVarPath = `/api/media-agency`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MediaAgencyBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Media Agency by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMediaAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteMediaAgency.');
            }
            const localVarPath = `/api/media-agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Media Agency by ID
         * @param {MediaAgencyBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMediaAgency(body: MediaAgencyBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editMediaAgency.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editMediaAgency.');
            }
            const localVarPath = `/api/media-agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MediaAgencyBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Media Agency by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mediaAgency.');
            }
            const localVarPath = `/api/media-agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Media Agencies
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaAgencyList(search?: string, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/media-agency`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaAgencyControllerApi - functional programming interface
 * @export
 */
export const MediaAgencyControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Media Agency
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMediaAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MediaAgencyControllerApiFetchParamCreator(configuration).activateMediaAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Media Agency
         * @param {MediaAgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediaAgency(body: MediaAgencyBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseMediaAgencyBeanObject> {
            const localVarFetchArgs = MediaAgencyControllerApiFetchParamCreator(configuration).createMediaAgency(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Media Agency by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMediaAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MediaAgencyControllerApiFetchParamCreator(configuration).deleteMediaAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Media Agency by ID
         * @param {MediaAgencyBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMediaAgency(body: MediaAgencyBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseMediaAgencyBeanObject> {
            const localVarFetchArgs = MediaAgencyControllerApiFetchParamCreator(configuration).editMediaAgency(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Media Agency by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseMediaAgencyBeanObject> {
            const localVarFetchArgs = MediaAgencyControllerApiFetchParamCreator(configuration).mediaAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Media Agencies
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaAgencyList(search?: string, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseMediaAgencyBean> {
            const localVarFetchArgs = MediaAgencyControllerApiFetchParamCreator(configuration).mediaAgencyList(search, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MediaAgencyControllerApi - factory interface
 * @export
 */
export const MediaAgencyControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Activate/Deactivate Media Agency
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMediaAgency(id: number, options?: any) {
            return MediaAgencyControllerApiFp(configuration).activateMediaAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Media Agency
         * @param {MediaAgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediaAgency(body: MediaAgencyBean, options?: any) {
            return MediaAgencyControllerApiFp(configuration).createMediaAgency(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Media Agency by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMediaAgency(id: number, options?: any) {
            return MediaAgencyControllerApiFp(configuration).deleteMediaAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Media Agency by ID
         * @param {MediaAgencyBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMediaAgency(body: MediaAgencyBean, id: number, options?: any) {
            return MediaAgencyControllerApiFp(configuration).editMediaAgency(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Media Agency by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaAgency(id: number, options?: any) {
            return MediaAgencyControllerApiFp(configuration).mediaAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Media Agencies
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaAgencyList(search?: string, active?: boolean, options?: any) {
            return MediaAgencyControllerApiFp(configuration).mediaAgencyList(search, active, options)(fetch, basePath);
        },
    };
};

/**
 * MediaAgencyControllerApi - object-oriented interface
 * @export
 * @class MediaAgencyControllerApi
 * @extends {BaseAPI}
 */
export class MediaAgencyControllerApi extends BaseAPI {
    /**
     * 
     * @summary Activate/Deactivate Media Agency
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaAgencyControllerApi
     */
    public activateMediaAgency(id: number, options?: any) {
        return MediaAgencyControllerApiFp(this.configuration).activateMediaAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Media Agency
     * @param {MediaAgencyBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaAgencyControllerApi
     */
    public createMediaAgency(body: MediaAgencyBean, options?: any) {
        return MediaAgencyControllerApiFp(this.configuration).createMediaAgency(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Media Agency by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaAgencyControllerApi
     */
    public deleteMediaAgency(id: number, options?: any) {
        return MediaAgencyControllerApiFp(this.configuration).deleteMediaAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Media Agency by ID
     * @param {MediaAgencyBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaAgencyControllerApi
     */
    public editMediaAgency(body: MediaAgencyBean, id: number, options?: any) {
        return MediaAgencyControllerApiFp(this.configuration).editMediaAgency(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Media Agency by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaAgencyControllerApi
     */
    public mediaAgency(id: number, options?: any) {
        return MediaAgencyControllerApiFp(this.configuration).mediaAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Media Agencies
     * @param {string} [search] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaAgencyControllerApi
     */
    public mediaAgencyList(search?: string, active?: boolean, options?: any) {
        return MediaAgencyControllerApiFp(this.configuration).mediaAgencyList(search, active, options)(this.fetch, this.basePath);
    }

}
/**
 * ReportControllerApi - fetch parameter creator
 * @export
 */
export const ReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(body: ReportRequestParameters, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createReport.');
            }
            const localVarPath = `/api/report/create`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportRequestParameters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsvReport(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCsvReport.');
            }
            const localVarPath = `/api/report/csv/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getReport.');
            }
            const localVarPath = `/api/report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInfo(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportInfo.');
            }
            const localVarPath = `/api/report/info/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportControllerApi - functional programming interface
 * @export
 */
export const ReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(body: ReportRequestParameters, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).createReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsvReport(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getCsvReport(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getReport(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInfo(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseReportBeanObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).reportInfo(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ReportControllerApi - factory interface
 * @export
 */
export const ReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {ReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(body: ReportRequestParameters, options?: any) {
            return ReportControllerApiFp(configuration).createReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsvReport(id: string, options?: any) {
            return ReportControllerApiFp(configuration).getCsvReport(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(id: string, options?: any) {
            return ReportControllerApiFp(configuration).getReport(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInfo(id: string, options?: any) {
            return ReportControllerApiFp(configuration).reportInfo(id, options)(fetch, basePath);
        },
    };
};

/**
 * ReportControllerApi - object-oriented interface
 * @export
 * @class ReportControllerApi
 * @extends {BaseAPI}
 */
export class ReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {ReportRequestParameters} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public createReport(body: ReportRequestParameters, options?: any) {
        return ReportControllerApiFp(this.configuration).createReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getCsvReport(id: string, options?: any) {
        return ReportControllerApiFp(this.configuration).getCsvReport(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getReport(id: string, options?: any) {
        return ReportControllerApiFp(this.configuration).getReport(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public reportInfo(id: string, options?: any) {
        return ReportControllerApiFp(this.configuration).reportInfo(id, options)(this.fetch, this.basePath);
    }

}
/**
 * SspControllerApi - fetch parameter creator
 * @export
 */
export const SspControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate SSP
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSsp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling activateSsp.');
            }
            const localVarPath = `/api/ssp/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new SSP
         * @param {SspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsp(body: SspBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSsp.');
            }
            const localVarPath = `/api/ssp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete SSP by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSsp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteSsp.');
            }
            const localVarPath = `/api/ssp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update SSP by ID
         * @param {SspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSsp(body: SspBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editSsp.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editSsp.');
            }
            const localVarPath = `/api/ssp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SSP by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssp.');
            }
            const localVarPath = `/api/ssp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all SSPs
         * @param {string} [search] 
         * @param {string} [type] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspList(search?: string, type?: string, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/ssp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SspControllerApi - functional programming interface
 * @export
 */
export const SspControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate SSP
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSsp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).activateSsp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new SSP
         * @param {SspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsp(body: SspBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).createSsp(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete SSP by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSsp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).deleteSsp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update SSP by ID
         * @param {SspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSsp(body: SspBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).editSsp(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get SSP by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).ssp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all SSPs
         * @param {string} [search] 
         * @param {string} [type] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspList(search?: string, type?: string, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSspBean> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).sspList(search, type, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SspControllerApi - factory interface
 * @export
 */
export const SspControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Activate/Deactivate SSP
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSsp(id: number, options?: any) {
            return SspControllerApiFp(configuration).activateSsp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new SSP
         * @param {SspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsp(body: SspBean, options?: any) {
            return SspControllerApiFp(configuration).createSsp(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete SSP by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSsp(id: number, options?: any) {
            return SspControllerApiFp(configuration).deleteSsp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update SSP by ID
         * @param {SspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSsp(body: SspBean, id: number, options?: any) {
            return SspControllerApiFp(configuration).editSsp(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get SSP by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssp(id: number, options?: any) {
            return SspControllerApiFp(configuration).ssp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all SSPs
         * @param {string} [search] 
         * @param {string} [type] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspList(search?: string, type?: string, active?: boolean, options?: any) {
            return SspControllerApiFp(configuration).sspList(search, type, active, options)(fetch, basePath);
        },
    };
};

/**
 * SspControllerApi - object-oriented interface
 * @export
 * @class SspControllerApi
 * @extends {BaseAPI}
 */
export class SspControllerApi extends BaseAPI {
    /**
     * 
     * @summary Activate/Deactivate SSP
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public activateSsp(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).activateSsp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new SSP
     * @param {SspBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public createSsp(body: SspBean, options?: any) {
        return SspControllerApiFp(this.configuration).createSsp(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete SSP by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public deleteSsp(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).deleteSsp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update SSP by ID
     * @param {SspBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public editSsp(body: SspBean, id: number, options?: any) {
        return SspControllerApiFp(this.configuration).editSsp(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get SSP by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public ssp(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).ssp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all SSPs
     * @param {string} [search] 
     * @param {string} [type] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public sspList(search?: string, type?: string, active?: boolean, options?: any) {
        return SspControllerApiFp(this.configuration).sspList(search, type, active, options)(this.fetch, this.basePath);
    }

}
/**
 * SspReportControllerApi - fetch parameter creator
 * @export
 */
export const SspReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} start 
         * @param {string} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspReport(key: string, start: string, end: string, options: any = {}): FetchArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling sspReport.');
            }
            // verify required parameter 'start' is not null or undefined
            if (start === null || start === undefined) {
                throw new RequiredError('start','Required parameter start was null or undefined when calling sspReport.');
            }
            // verify required parameter 'end' is not null or undefined
            if (end === null || end === undefined) {
                throw new RequiredError('end','Required parameter end was null or undefined when calling sspReport.');
            }
            const localVarPath = `/ssp-report`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any).toISOString();
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SspReportControllerApi - functional programming interface
 * @export
 */
export const SspReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} start 
         * @param {string} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspReport(key: string, start: string, end: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: SspReportDay; }> {
            const localVarFetchArgs = SspReportControllerApiFetchParamCreator(configuration).sspReport(key, start, end, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SspReportControllerApi - factory interface
 * @export
 */
export const SspReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} start 
         * @param {string} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspReport(key: string, start: string, end: string, options?: any) {
            return SspReportControllerApiFp(configuration).sspReport(key, start, end, options)(fetch, basePath);
        },
    };
};

/**
 * SspReportControllerApi - object-oriented interface
 * @export
 * @class SspReportControllerApi
 * @extends {BaseAPI}
 */
export class SspReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} key 
     * @param {string} start 
     * @param {string} end 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspReportControllerApi
     */
    public sspReport(key: string, start: string, end: string, options?: any) {
        return SspReportControllerApiFp(this.configuration).sspReport(key, start, end, options)(this.fetch, this.basePath);
    }

}



// WEBPACK FOOTER //
// ./src/api/api.ts